module.exports = "/call-frontend/img/icon_eye_hidden.8efefc36.svg";